import React, { useState, useEffect, useRef } from "react";
import { Prompt } from "react-router";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  message,
  Space,
  Row,
  Col,
  Select,
  Empty,
  Menu,
  Dropdown,
  Spin,
  Switch,
  Typography,
  Tag,
} from "antd";
import {
  getPayMethodById,
  editPayMethod,
  getNewPayMethodCode,
} from "../../services/Items/payMethodService";
import { getActiveAccountSearch } from "../../services/AccountService";
import { RetweetOutlined } from "@ant-design/icons";
import _t from "../../languages/translate";
import { objCountNum } from "../helper/countOfZero";
import { handleEx } from "../helper/handleException";
import InputCurrency from "../helper/Input/InputCurrency";
import { getAuth } from "../../services/Authorization/userRoleService";
import { authKeys } from "../../services/Authorization/authKeys";
import SelectAccount from "../helper/inputSelect/selectAccount";
import { shortCut } from "../helper/shortCuts";
const PayMethodForm = () => {
  const IX_Code = useRef(null);
  const IX_NameAr = useRef(null);
  const IX_NameEn = useRef(null);
  const [loading] = useState(false);
  const [proChange, setProChange] = useState(false);
  const [loadData, setLoadData] = useState(true);
  const [visaCommBankOpt, setVisaCommBankOpt] = useState([]);
  const [visaBankOpt, setVisaBankOpt] = useState([]);
  const [form] = Form.useForm();
  let history = useHistory();
  let { id } = useParams();
  const [isGoBack, setIsGoBack] = useState(true);
  const { Text } = Typography;
  //////////----|👉 start auth|----//////////
  // perDelete
  // perExcel
  // perPdf
  // perPost
  // perPrint
  // perPut
  // perView
  //-----------------------------------------
  const [auth, setAuth] = useState({});
  const authorization = async () => {
    const obj = JSON.parse(localStorage.getItem("auth"));
    if (obj !== null) {
      const responce = obj.filter((e) => e?.roleKey === authKeys.finalAcc)[0];
      setAuth(responce);
    } else {
      try {
        const data = await getAuth();
        localStorage.setItem("auth", JSON.stringify(data.data.data));
        authorization();
      } catch (ex) {
        return null;
      }
    }
  };
  //////////----|👉 end auth|----//////////
  const codeGenerator = async () => {
    const { data: newData } = await getNewPayMethodCode();
    form.setFieldsValue({ code: newData.data, visaCommPerc: 0 });
    IX_NameAr.current.focus();
    setLoadData(false);
  };

  const visaCommBankOptList =
    visaCommBankOpt.length > 0 &&
    visaCommBankOpt.map((item) => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));
  const visaBankOptList =
    visaBankOpt.length > 0 &&
    visaBankOpt.map((item) => (
      <Select.Option key={item.id} value={item.id}>
        {item.name}
      </Select.Option>
    ));

  useEffect(() => {
    async function fetchData() {
      handleVisaBank("");
      handleVisaCommBank("");
      if (id === "new") {
        return await codeGenerator();
      } else {
        try {
          const { data } = await getPayMethodById(id);
          form.setFieldsValue({
            id: data.data.Id,
            code: data.data.code,
            nameAr: data.data.nameAr,
            nameEn: data.data.nameEn,
            visaCommPerc: data.data.visaCommPerc,
            inactive: data.data.inactive,
            visaBankAccId: data.data.visaBankAccId,
            visaCommBankAccId: data.data.visaCommBankAccId,
          });
          IX_NameAr.current.focus();
        } catch (error) {
          handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
        } finally {
          setLoadData(false);
        }
      }
    }
    fetchData();
  }, [id, history, setLoadData]);

  //******************************// //*******************// Back //*******************// //******************************//

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setIsGoBack(true)}>
        {_t("strLeaveThePage")}
      </Menu.Item>
      <Menu.Item onClick={() => setIsGoBack(false)}>
        {_t("strStayInPage")}
      </Menu.Item>
    </Menu>
  );

  const goBack = () => {
    if (isGoBack) {
      history.goBack();
    } else {
      form.resetFields();
      history.replace({ ...history.location, pathname: "/payMethod/new" });
      codeGenerator();
      IX_NameAr.current.focus();
    }
  };

  //******************************// //*******************// Save //*******************// //******************************//

  const onFinish = async (values) => {
    setLoadData(true);
    setProChange(false);
    values.id = id;
    try {
      const data = await editPayMethod(values);
      setLoadData(false);
      message.success(data.data.message, 3);
      goBack();
    } catch (error) {
      setLoadData(false);
      handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
    } finally {
      setLoadData(false);
    }
  };

  const [altPress, setAltPress] = useState(false);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      const confState = JSON.parse(window.sessionStorage.getItem("confState"));
      let showModal = JSON.parse(window.sessionStorage.getItem("showModal"));
      if (showModal === false || showModal === null) {
        if (!confState) {
          switch (shortCut(e)) {
            case "save":
              form.submit();
              break;
            case "search":
              IX_Code?.current?.focus();
              IX_Code?.current?.select();
              break;
            case "block1":
              IX_NameAr?.current?.focus();
              break;
            case "tag":
              setAltPress(true);
              break;
            default:
              break;
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keydown", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      if (e.keyCode === 18) {
        setAltPress(false);
      }
    };
    window.addEventListener("keyup", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("keyup", handleKeydownOnEdit);
    };
  }, []);

  useEffect(() => {
    const handleKeydownOnEdit = (e) => {
      setAltPress(false);
    };
    window.addEventListener("blur", handleKeydownOnEdit);
    return () => {
      window.removeEventListener("blur", handleKeydownOnEdit);
    };
  }, []);

  //******************************// //*******************// Form //*******************// //******************************//

  const handleVisaCommBank = async (_Search) => {
    try {
      const { data: responce } = await getActiveAccountSearch(_Search);

      setVisaCommBankOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
    } finally {
      setLoadData(false);
    }
  };

  const handleVisaBank = async (_Search) => {
    try {
      const { data: responce } = await getActiveAccountSearch(_Search);

      setVisaBankOpt(responce.data);
    } catch (error) {
      handleEx(error, { IX_Code, IX_NameAr, IX_NameEn });
    } finally {
      setLoadData(false);
    }
  };

  return (
    <React.Fragment>
      <Prompt when={proChange} message={_t("strUnsavedChanges")} />
      <Spin spinning={loadData} tip={_t("strLoading")}>
        <Form
          form={form}
          name="payMethodForm"
          onFinish={onFinish}
          layout="horizontal"
          labelCol={{
            flex: "150px",
          }}
          wrapperCol={{
            span: 20,
          }}
        >
          <div name="code" className="frHeader">
            <Row>
              <Col xs={24} md={24}>
                <Space split="#">
                  <Space split="\">
                    <Text>{_t("strDefinitions")}</Text>
                    <Text style={{ fontWeight: 700 }}>
                      {_t("strPayMethods")}
                    </Text>
                  </Space>
                  <div>
                    <Form.Item
                      name="code"
                      rules={[
                        { required: true, message: `${_t("strIsRequired")}` },
                        { min: 1, message: `${_t("strFrom3-200")}` },
                        { max: 200, message: `${_t("strFrom3-200")}` },
                      ]}
                    >
                      <Input
                        className="inpCode"
                        size="small"
                        placeholder={_t("strCode")}
                        maxLength={200}
                        autoComplete="off"
                        onKeyDown={() => setProChange(true)}
                        ref={IX_Code}
                        bordered={false}
                      />
                    </Form.Item>
                    <div
                      style={{
                        opacity: 0.8,
                        zIndex: 99,
                        position: "absolute",
                        top: 24,
                      }}
                    >
                      <Tag color="#2b2b2b" hidden={!altPress}>
                        alt + F
                      </Tag>
                    </div>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>

          <div name="field" className="frContent">
            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="nameAr"
                  label={
                    <div>
                      {_t("strNameAr")}
                      <div
                        style={{
                          opacity: 0.8,
                          zIndex: 99,
                          position: "absolute",
                          top: 4,
                        }}
                      >
                        <Tag color="#2b2b2b" hidden={!altPress}>
                          alt + 1
                        </Tag>
                      </div>
                    </div>
                  }
                  rules={[
                    { required: true, message: `${_t("strIsRequired")}` },
                    { min: 1, message: `${_t("strFrom3-200")}` },
                    { max: 200, message: `${_t("strFrom3-200")}` },
                  ]}
                >
                  <Input
                    placeholder={_t("strNameAr")}
                    maxLength={200}
                    autoComplete="off"
                    size="small"
                    onKeyDown={() => setProChange(true)}
                    ref={IX_NameAr}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="nameEn"
                  label={_t("strNameEn")}
                  rules={[
                    { required: true, message: `${_t("strIsRequired")}` },
                    { min: 1, message: `${_t("strFrom3-200")}` },
                    { max: 200, message: `${_t("strFrom3-200")}` },
                  ]}
                >
                  <Input
                    placeholder={_t("strNameEn")}
                    maxLength={200}
                    autoComplete="off"
                    size="small"
                    onKeyDown={() => setProChange(true)}
                    ref={IX_NameEn}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item name="visaCommPerc" label={_t("strCommission")}>
                  {/* count of zero by types name >> ( qty: 3, value: 2, currency: 5, rate: 5, equivlent:5, perc:2 )~*/}
                  <InputCurrency
                    precision={objCountNum.perc}
                    min={0}
                    max={100}
                    suffix="%"
                    size="small"
                    style={{ width: "100%" }}
                    onChange={() => setProChange(true)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="visaBankAccId" label={_t("strVisaAcc")}>
                  <SelectAccount
                    addId={form.getFieldValue("visaBankAccId")}
                    placeholder={_t("strVisaAcc")}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="visaCommBankAccId"
                  label={_t("strVisaCommissionAcc")}
                >
                  <SelectAccount
                    addId={form.getFieldValue("visaCommBankAccId")}
                    placeholder={_t("strVisaCommissionAcc")}
                  />

                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="inactive"
                  valuePropName="checked"
                  label={_t("strInActive")}
                >
                  <Switch size="small" />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="frFooter">
            <Form.Item>
              <Space size="large">
                {!auth?.perPut && (
                  <div>
                    <Button
                      type="primary"
                      size="small"
                      htmlType="submit"
                      disabled={loading}
                    >
                      {_t("strSave")}
                    </Button>
                    <div
                      style={{
                        opacity: 0.8,
                        zIndex: 99,
                        position: "absolute",
                        top: 24,
                      }}
                    >
                      <Tag color="#2b2b2b" hidden={!altPress}>
                        alt + S
                      </Tag>
                    </div>
                  </div>
                )}
                <Dropdown.Button
                  hidden={typeof onNewStore === "function"}
                  overlay={menu}
                  onClick={() => {
                    history.action === "PUSH"
                      ? history.goBack()
                      : history.push("/payMethod");
                  }}
                  size="small"
                >
                  {" "}
                  {_t("strBack")}
                </Dropdown.Button>
                {isGoBack ? (
                  <i />
                ) : (
                  <RetweetOutlined style={{ fontSize: 21, marginTop: 5 }} />
                )}
              </Space>
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </React.Fragment>
  );
};

export default PayMethodForm;
